// Below this the JS bundle may not parse. Drives vite.build.target and the inline fallback card.
export const BUILD_TARGET_MATRIX = {
  chrome: '110.0.0',
  firefox: '102.0.0',
  ios: '15.6.0',
  safari: '15.6.0',
} as const

// Below this the app runs, but with known defects (e.g. broken full-screen modals on iOS < 16.5).
// Drives the dismissable update modal. Must never be lower than BUILD_TARGET_MATRIX.
export const BROWSER_SUPPORT_MATRIX = {
  chrome: '110.0.0',
  firefox: '102.0.0',
  ios: '16.5.0',
  macos: '10.15.0',
  safari: '16.5.0',
} as const

export type BuildTargetEngine = keyof typeof BUILD_TARGET_MATRIX

const ESBUILD_TARGET_ENGINES = Object.keys(BUILD_TARGET_MATRIX) as BuildTargetEngine[]

export const VITE_BUILD_TARGET = ESBUILD_TARGET_ENGINES.map((engine) => {
  const [major, minor] = BUILD_TARGET_MATRIX[engine].split('.')
  return minor && minor !== '0' ? `${engine}${major}.${minor}` : `${engine}${major}`
})
